<script>
  import BrandLayout from '../components/Layout'
  import ListFileTable from "@components/List/FileTable";
  import { brandComputed } from '@store/helpers'
  import pageGAMixin from "../mixins/pageGA";

  export default {
    page() {
      return {
        title: `${this.defaultValue.title} | 產品系列`,
      }
    }, 
    components: {
      BrandLayout,
      ListFileTable
    },
    mixins: [pageGAMixin],
    props: {
      defaultValue: {
        type: Object,
        default: () => {
        }
      }
    },
    data() {
      return {
        type: 'product',

      }
    },
    computed: {
      ...brandComputed
    },
    
    methods: {
      backTo() {
        const name = () => {
          switch(this.$route.name) {
            case 'product-item':
              return 'product-list';
            case 'brand-product-item':
              return 'brand-product-list'
          }
        };
        const params = () => {
          switch(this.$route.name) {
            case 'product-item':
              return undefined;
            case 'brand-product-item':
              return {
                brandAlias: this.$route.params.brandAlias,
              };
          }
        };
        return {
          name: name(),
          params: params()
        }
      },
      
    }
  }
</script>
<template>
  <BrandLayout :page-type="type">
    <BaseBanner
      :title="defaultValue.title"
      type="article"
      :image="''"
      class="d-lg-block d-none"
    />
    <section :class="$style.sectionProductItem" class="section">
      <div class="container">
        <div class="font-medium text-xl mb-3 d-md-none">{{defaultValue.title}}</div>
        <div class="row">
          <div
            v-if="defaultValue.description"
            class="mb-5 col-12 text-gray-6 sectionProductItem__description article"
            v-html="defaultValue.description">
          </div>
          <div class="col-12">
            <ListFileTable
              :list="defaultValue.product_data"
              type="product"
            />
          </div>
        </div>
        <div class="text-center mt-4">
          <BaseButton
            class="isStylePrimary isSmall isRadius isOutline2 sectionProductItem__Btn"
            :to="backTo()"
          >
            <i class="far fa-chevron-left text-sm align-middle"></i>
            回到產品列表
          </BaseButton>
        </div>
      </div>
    </section>
  </BrandLayout>
</template>

<style lang="scss" module>
  .sectionProductItem {
    :global {
      .sectionProductItem {
        &__description {
          line-height: 2;
        }
        &__Btn {
          @include max-lg {
            width: 100%;
            margin-bottom: 2rem;
          }
        }
      }
    }
  }
</style>
